import { render, staticRenderFns } from "./TvWinEdit.vue?vue&type=template&id=5abe474a&scoped=true&"
import script from "./TvWinEdit.vue?vue&type=script&lang=js&"
export * from "./TvWinEdit.vue?vue&type=script&lang=js&"
import style0 from "./TvWinEdit.vue?vue&type=style&index=0&id=5abe474a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abe474a",
  null
  
)

export default component.exports